var browser = require('browser');

var FaviconView = Backbone.View.extend({
    size: 16,
    initialize: function (options) {
        this.model.buffers.bind('unseenHighlightChange', this.render, this);
        this.model.bind('unseenChange', this.render, this);

        if (browser.isHighDensity()) {
            this.url = '/static/favicon/favicon-32x32.png';
        } else {
            this.url = '/static/favicon/favicon-16x16.png';
        }
        this.img = $('<img>').attr('src', this.url)[0];
        this.canvas = $('<canvas>')[0];
    },
    getUnseenMessageStats: function () {
        if (!this.model.unseenBuffers.length) {
            return false;
        }
        var count = 0;
        this.model.unseenBuffers.each(function (buffer) {
            count += buffer.unseenHighlightCount();
        }, this);
        return count;
    },

    render: function () {
        try {
            var iconUrl = this.getIconUrl();
            this.setFavicon(iconUrl);
        } catch (e) {
            // Can error if the image url fails
        }
    },
    pxr: function (val) {
        return val * browser.getPixelRatio();
    },
    rect: function (ctx, x, y, width, height, radius) {
        ctx.beginPath();
        ctx.moveTo(x + radius, y);
        ctx.lineTo(x + width - radius, y);
        ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - radius);
        ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + radius, y + height);
        ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + radius);
        ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();    
    },
    getIconUrl: function () {
        var stats = this.getUnseenMessageStats();
        var canvasSize = this.pxr(this.size);
        this.canvas.height = this.canvas.width = canvasSize;
        var ctx = this.canvas.getContext('2d');
        // Base icon
        ctx.drawImage(this.img, 0, 0, canvasSize, canvasSize);
        // stats = false;
        if (stats) {
            // Circle
            ctx.fillStyle = '#ff1f1a';
            var radius = this.pxr(2.5);
            var margin = this.pxr(1);
            var originX = canvasSize - radius - margin;
            var originY = margin + radius;
            ctx.beginPath();
            ctx.arc(originX, originY, radius, 0, 2*Math.PI);
            ctx.fill();
        }
        return this.canvas.toDataURL('image/png');
    },
    setFavicon: function (iconUrl) {
        $('head').find('link[rel=icon]').attr('href', iconUrl);
    }
});


module.exports = FaviconView;



//////////////////
// WEBPACK FOOTER
// ./app/src/view/faviconview.js
// module id = xgw8
// module chunks = 1